import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import api from '../api'
import { ENDPOINTS } from '@/config/api.config'

const CONTACTS_KEY = ['super-admin', 'contacts']

export type ContactStatus = 'novo' | 'em_contato' | 'convertido' | 'descartado'

export interface CompanyContact {
  id: string
  name: string
  company: string
  email: string
  phone: string | null
  status: ContactStatus
  notes: string | null
  source: string
  /** null = o e-mail de notificação pro time não foi entregue. */
  notifiedAt: string | null
  updatedBy: string | null
  createdAt: string
  updatedAt: string
}

export interface UpdateContactDTO {
  status?: ContactStatus
  notes?: string | null
}

/** Lista os contatos comerciais recebidos pela landing (super_admin). */
export function useCompanyContacts(enabled = true) {
  return useQuery<CompanyContact[]>({
    queryKey: CONTACTS_KEY,
    queryFn: async () => {
      const { data } = await api.get<CompanyContact[]>(ENDPOINTS.contacts.list)
      return data
    },
    staleTime: 60 * 1000,
    enabled,
  })
}

export function useUpdateCompanyContact() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, ...dto }: UpdateContactDTO & { id: string }) => {
      const { data } = await api.patch<CompanyContact>(ENDPOINTS.contacts.byId(id), dto)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CONTACTS_KEY })
    },
  })
}
